/* eslint-disable react/require-default-props */
import React from 'react';
import Brushaway from '@components/Brushaway';
import { translate } from '@utils/i18n';
import './TalkToSalesFormStyles.scss';
import { Button } from '@ui';
const namespace = 'whats_new_modal';
const PRODUCT_PAGE_URL = 'https://www.inspectpoint.com/inspection-assistant-customer-product';
export default function TalkToSalesForm({ isOpen, onClose }) {
    const handleOpenProductPage = () => {
        // Open from user gesture (click) to avoid popup blocker
        // Use noopener,noreferrer to prevent reverse-tabnabbing attacks
        window.open(PRODUCT_PAGE_URL, '_blank', 'noopener,noreferrer');
        onClose();
    };
    return (React.createElement(Brushaway, { open: isOpen, onClose: onClose, title: translate('talk_to_sales_title', { namespace }), customFooter: React.createElement("div", { className: "whats-new-modal__footer" },
            React.createElement(Button, { onClick: onClose }, translate('close', { namespace })),
            React.createElement(Button, { variant: "primary", onClick: handleOpenProductPage }, translate('talk_to_sales', { namespace }))), minWidth: 960, wrapperContentClassName: "talk-to-sales-form" },
        React.createElement("p", { className: "talk-to-sales-form__description" }, translate('sales_explanation', { namespace }))));
}
